import { useEffect, useState } from "react";
import { BACKEND_URL } from "../lib/api";

export function resolveCoworkingMediaUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("//")) return `https:${raw}`;
  if (raw.startsWith("/")) return `${BACKEND_URL}${raw}`;
  return raw;
}

export function initialsForCoworkingName(value) {
  const clean = String(value || "").replace(/[_-]+/g, " ").trim();
  if (!clean) return "?";
  const words = clean.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return clean.slice(0, 2).toUpperCase();
}

/**
 * Face or initials for coworking boards/overlays.
 * Resolves API-relative avatar paths and never leaves a broken <img>.
 */
export default function CoworkingTaskAvatar({
  avatarUrl,
  name,
  className = "",
  size = 32,
  testId,
}) {
  const resolved = resolveCoworkingMediaUrl(avatarUrl);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [resolved]);

  const initials = initialsForCoworkingName(name);
  const dimStyle = { width: size, height: size };

  if (!resolved || failed) {
    return (
      <span
        className={`coworking-task-avatar coworking-task-avatar-fallback ${className}`.trim()}
        style={dimStyle}
        aria-hidden="true"
        data-testid={testId}
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      className={`coworking-task-avatar ${className}`.trim()}
      style={dimStyle}
      src={resolved}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      data-testid={testId}
      onError={() => setFailed(true)}
    />
  );
}
